// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2nmhb","bigColWidth":"Table_bigColWidth__1MDLo","biggerColWidth":"Table_biggerColWidth__3hj39","row":"Table_row__3odOA","col":"Table_col__3zWTc"};